"use client";

import { UTM_COOKIE_KEYS } from "./constants";
import type { UtmParams } from "./types";

export function getUtmCookieValues(): UtmParams {
  if (typeof document === "undefined") return {};

  const parsed: UtmParams = {};

  for (const cookie of document.cookie.split(";")) {
    const trimmed = cookie.trim();
    const eqIndex = trimmed.indexOf("=");

    if (eqIndex > 0) {
      const name = trimmed.slice(0, eqIndex).trim();
      const value = trimmed.slice(eqIndex + 1).trim();
      const isUtmKey = UTM_COOKIE_KEYS.includes(
        name as (typeof UTM_COOKIE_KEYS)[number],
      );

      if (value && isUtmKey) {
        try {
          parsed[name as (typeof UTM_COOKIE_KEYS)[number]] =
            decodeURIComponent(value);
        } catch {
          parsed[name as (typeof UTM_COOKIE_KEYS)[number]] = value;
        }
      }
    }
  }

  return parsed;
}
